import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Layout::Stack @gap=\'large\' as |Item|>\n  {{yield (component \'module/step-list/-item\' wrapper=Item)}}\n</Layout::Stack>")